import React, {useEffect} from 'react';
import {ClipboardText} from '@phosphor-icons/react';
import {Tab} from '../../../../components';
import TreeProperties from './TreeProperties';
import {useViewerStore} from "../../../../store/store";

const Tree: React.FC = () => {
    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const items = [
        {
            icon: (<ClipboardText size={24} weight='fill'/>),
            content: (<TreeProperties/>),
            title: 'Tree Properties',
            is_active: true,
        },
    ];

    useEffect(() => {
        if (sceneViewer) sceneViewer.setTabInfo('Tree Properties');
    }, []);

    return ( <Tab items={items}/> );
}

export default Tree;